import { Component, inject, input, resource } from '@angular/core';
import { Api } from '../../../../core/clients/portal/api';
import { getFileContent } from '../../../../core/clients/portal/functions';
import { FileResponse } from '../../../../core/clients/omni-core/models';

@Component({
  selector: 'app-document-text',

  templateUrl: './document-text.html',
})
export class DocumentText {
  private api = inject(Api);

  document = input.required<FileResponse>();
  organizationID = input.required<string>();

  protected fileContent = resource({
    params: () => ({
      id: this.document().id,
      oid: this.organizationID(),
    }),
    loader: ({ params }) => this.api.invoke(getFileContent, params),
  });
}
